export class SubService {
    id: string;
    name: string;
    imageUrl: string;
    rate: number;
    serviceId: string;
    serviceName: string;
    constructor() {
        this.id = '';
        this.name = '';
        this.imageUrl = '';
        this.rate = 0;
        this.serviceId = '';
        this.serviceName = '';
    }
}
